if (window.__fpProductCompareV11Loaded) {
  console.warn('[FP compare] fp-product-compare-v1.1.js already loaded; skipping duplicate init');
} else {
  window.__fpProductCompareV11Loaded = true;
console.log('[FP compare] fp-product-compare.js final product-only 2026-05-04 loaded');
/* ------------------------------------------------------------
   FP Product Compare Debug/Fact patch
   ------------------------------------------------------------ */
var FP_COMPARE_DEBUG = /[?&]fp_compare_debug=1(?:&|$)/.test(window.location.search);

// Max compare columns (excluding the left label column)
// Firepot compare: current + up to 5 Firepot meals
// Wet compare: current + up to 2 wet meals
var MAX_COLS_FIREPOT = 6;
var MAX_COLS_WET = 3;

// Current mode max cols (will be set inside render)
var CURRENT_MAX_COLS = MAX_COLS_FIREPOT;

// Shared pouch images (used in wet module + competitor header)
var FP_POUCH_IMG = 'https://cdn.shopify.com/s/files/1/1596/8375/files/fp.png?v=1769611102';
var WET_POUCH_IMG = 'https://cdn.shopify.com/s/files/1/1596/8375/files/sample-pouch.png?v=1777884599';

/* ==========================================================================
   FP PRODUCT COMPARE v1.1
   - One combined dropdown (competitors + Firepot)
   - Auto-add on selection (no Add button)
   - Grey-out/disable already added + current product
   ========================================================================== */

(function () {
  var CURRENT_PRICE_GBP = null;
  if (window.__fpProductCompareBooted) return;

    async function ensureCurrentPriceGbp() {
      if (CURRENT_PRICE_GBP != null) return CURRENT_PRICE_GBP;
      try {
        var res = await fetch('/products/' + encodeURIComponent(currentHandle) + '.js', { credentials: 'same-origin' });
        if (!res.ok) return null;
        var pj = await res.json();
        var v = pj && pj.variants && pj.variants[0] ? pj.variants[0] : null;
        if (v && v.price != null) {
          CURRENT_PRICE_GBP = toNumber(v.price) / 100.0;
          return CURRENT_PRICE_GBP;
        }
      } catch (e) {}
      return null;
    }

  window.__fpProductCompareBooted = true;
  function qs(sel, root) { return (root || document).querySelector(sel); }
  
  
  
  function moveFactsTitleOutside(root){
    try{
      var wf = qs('.fp-compare__wetFacts', root);
      if(!wf) return;

      // Find the title wherever it currently lives within the wet facts UI
      var title = qs('.fp-compare__factsTitle', root);
      if(!title) return;

      // If we've already created an external heading, do nothing
      if(qs('.fp-compare__factsTitleOutside', root)) return;

      var outside = document.createElement('div');
      outside.className = 'fp-compare__factsTitleOutside';
      outside.textContent = (title.textContent || 'How do we compare?').trim();

      // Insert heading immediately before the grey box (wetFacts container)
      wf.parentNode.insertBefore(outside, wf);

      // Remove original title element from DOM to prevent it showing inside the box
      title.parentNode.removeChild(title);
    }catch(e){}
  }
function qsa(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function safeParse(txt) { try { return JSON.parse(txt); } catch (e) { return null; } }

  var debug = /(?:\?|&)fp_compare_debug=1(?:&|$)/.test(location.search);
  function log() { if (!debug) return; try { console.log.apply(console, ['[FP product compare]'].concat([].slice.call(arguments))); } catch (e) {} }


  // ===============================
  // FP Compare debug keylines
  // Enable with ?fp_compare_keylines=1
  // ===============================
  function debugKeylinesEnabled(){
    return debug || /(?:\?|&)fp_compare_keylines=1(?:&|$)/.test(location.search);
  }
  function applyDebugKeylines(scope){
    if (!debugKeylinesEnabled()) return;
    try{
      var root = scope || document;
      // Add a global hook so CSS selectors always match
      document.documentElement.classList.add('fp-compare--debug');
      if (document.body) document.body.classList.add('fp-compare--debug');

      // Also outline key elements inline (can't be overridden by missing CSS)
      qsa('.fp-compare__wetFacts', root).forEach(function(n){ n.style.outline='2px dashed rgba(0,128,255,0.55)'; n.style.outlineOffset='-2px'; n.style.marginTop='0'; n.style.marginBottom='0'; });
      qsa('.fp-compare__factsBox', root).forEach(function(n){ n.style.outline='2px solid rgba(0,200,120,0.6)'; n.style.outlineOffset='-2px'; });
      qsa('.fp-compare__factsTitle', root).forEach(function(n){ n.style.outline='2px dashed rgba(255,165,0,0.8)'; n.style.outlineOffset='2px'; });
      qsa('.fp-compare__pouchEqGraphic', root).forEach(function(n){ n.style.outline='2px solid rgba(160,0,255,0.55)'; n.style.outlineOffset='2px'; });
      qsa('.fp-compare__wetSummary', root).forEach(function(n){ n.style.outline='2px dashed rgba(0,0,0,0.35)'; n.style.outlineOffset='2px'; });

            qsa('.fp-compare__wetFacts', root).forEach(function(n){ if (n.style && n.style.marginTop && n.style.marginTop !== '0px' && n.style.marginTop !== '0') console.warn('[FP compare] wetFacts has inline marginTop', n.style.marginTop, n); });
console.log('[FP compare] keylines ON');
    }catch(e){
      console.warn('[FP compare] keylines failed', e);
    }
  }
  function writeDebugMetrics(wrap){
    if (!debugKeylinesEnabled() || !wrap) return;
    try{
      var host = qs('.fp-compare__wetFacts .fp-compare__factsBox', wrap) || qs('.fp-compare__factsBox', wrap) || wrap;
      var box = qs('.fp-compare__factsBox', host) || host;
      var g = qs('.fp-compare__pouchEqGraphic', host);
      var s = qs('.fp-compare__wetSummary', host);
      var t = qs('.fp-compare__factsTitle', host);

      var el = qs('.fp-compare__debugMetrics', host);
      if (!el){
        el = document.createElement('div');
        el.className = 'fp-compare__debugMetrics';
        host.insertBefore(el, host.firstChild);
      }
      el.textContent = 'factsBox ' + (box ? box.getBoundingClientRect().height.toFixed(1)+'px' : '—') +
        ' | title ' + (t ? t.getBoundingClientRect().height.toFixed(1)+'px' : '—') +
        ' | graphic ' + (g ? g.getBoundingClientRect().height.toFixed(1)+'px' : '—') +
        ' | summary ' + (s ? s.getBoundingClientRect().height.toFixed(1)+'px' : '—');
    }catch(e){}
  }

  var NUTRI_ROWS = [
    { key: 'energy_kcal', label: 'Energy (kcal)', unit: 'kcal' },
    { key: 'fat_g', label: 'Fat', unit: 'g' },
    { key: 'saturates_g', label: 'of which saturates', unit: 'g', indent: true },
    { key: 'carbohydrate_g', alt: ['carbs_g', 'carbohydrates_g'], label: 'Carbohydrates', unit: 'g' },
    { key: 'sugars_g', label: 'of which sugars', unit: 'g', indent: true },
    { key: 'fibre_g', label: 'Fibre', unit: 'g' },
    { key: 'protein_g', label: 'Protein', unit: 'g' },
    { key: 'salt_g', label: 'Salt', unit: 'g' }
  ];


  function buildMetaRow(label, products, getter, kind) {
    var row = '<tr class="fp-compare__row fp-compare__row--meta">';
    row += '<th class="fp-compare__rowLabel">' + label + '</th>';
    for (var i = 0; i < CURRENT_MAX_COLS; i++) {
      var p = products[i];

      // Empty/unassigned columns should stay visually empty in meta rows
      // (RRP / Pouch weight), not show an em dash.
      if (!p) {
        row += '<td class="fp-compare__cell"></td>';
        continue;
      }

      var val = getter(p, i);
            // Ensure Firepot RRP always uses current product price
      if (kind === 'money' && label === 'RRP' && i === 0 && (typeof CURRENT_PRICE_GBP !== 'undefined') && CURRENT_PRICE_GBP !== null) {
        val = CURRENT_PRICE_GBP;
      }
var cell = '—';
      if (val !== null && val !== undefined && val !== '') {
        if (kind === 'money') cell = fmtMoney(toNumber(val));
        else if (kind === 'g') cell = fmtG(toNumber(val));
        else cell = String(val);
      }
      row += '<td class="fp-compare__cell">' + cell + '</td>';
    }
    row += '</tr>';
    return row;
  }

  function unwrap(v) { return (v && typeof v === 'object' && ('value' in v)) ? v.value : v; }
  function toText(v) {
    v = unwrap(v);
    if (v === null || v === undefined) return '';
    if (Array.isArray(v)) return v.map(function (x) { return String(unwrap(x) || '').trim(); }).filter(Boolean).join(', ');
    if (typeof v === 'object') return '';
    return String(v);
  }
  function toNumber(v) {
    v = unwrap(v);
    if (v === null || v === undefined || v === '') return null;
    var n = (typeof v === 'number') ? v : parseFloat(String(v).replace(/[^0-9.\-]/g, ''));
    return (isFinite(n) ? n : null);
  }

  function round1(n) {
    if (n === null || n === undefined || isNaN(n)) return null;
    return Math.round(n * 10) / 10;
  }
  function fmt1(n) {
    n = round1(n);
    if (n === null) return '—';
    return n.toFixed(1);
  }

  function normalizeCompetitorName(s){
    if (!s) return s;
    // Replace any spaced dash variants with a single space (Wayfayrer Pasta -> Wayfayrer Pasta)
    return String(s)
      .replace(/\s+[\u2014\u2013\-]\s+/g, ' ')
      .replace(/\s{2,}/g, ' ')
      .trim();
  }

  function fmtMoney(n) {
    if (n === null || n === undefined || isNaN(n)) return '—';
    return '£' + Number(n).toFixed(2);
  }
  function fmtG(n) {
    if (n === null || n === undefined || isNaN(n)) return '—';
    var nn = Number(n);
    if (Math.abs(nn - Math.round(nn)) < 0.05) return String(Math.round(nn)) + 'g';
    return nn.toFixed(1) + 'g';
  }
  function fmtKg(n) {
    if (n === null || n === undefined || isNaN(n)) return '—';
    return Number(n).toFixed(1) + 'kg';
  }

  function fmt(val, unit) {
    if (val === null || val === undefined || val === '') return '--';
    var num = (typeof val === 'number') ? val : parseFloat(val);
    if (!isNaN(num) && isFinite(num)) {
      if (unit === 'kcal') return String(Math.round(num)) + unit;
      if (unit === 'ml') return String(Math.round(num)) + unit;
      return num.toFixed(1) + unit;
    }
    return String(val) + unit;
  }
  function escapeHtml(s) {
    return String(s || '').replace(/[&<>"']/g, function (c) {
      return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]);
    });
  }

  function isCompetitor(handle) { return typeof handle === 'string' && handle.indexOf('comp:') === 0; }
  function normTags(s) {
    return String(s || '').toLowerCase().split(',').map(function (t) { return t.trim(); }).filter(Boolean);
  }
  function hasTag(tags, needle) {
    if (!needle) return false;
    needle = String(needle).toLowerCase();
    if (needle === 'glutenfree') {
      return tags.indexOf('gluten free') >= 0 || tags.indexOf('gluten-free') >= 0 || tags.indexOf('glutenfree') >= 0;
    }
    return tags.indexOf(needle) >= 0;
  }

  function makeState() { return { maxCols: 6, view: '', selected: [] }; }

  function isProductCompareMobile() {
    return !!(window.matchMedia && window.matchMedia('(max-width: 699px)').matches);
  }

  function loadCompetitors(panel) {
    var competitorMeals = [];
    var s = qs('script[data-fp-compare-competitors]', panel);
    var parsed = s ? safeParse(s.textContent || '') : null;

    if (Array.isArray(parsed)) competitorMeals = parsed;
    else if (parsed && parsed.meals && Array.isArray(parsed.meals)) competitorMeals = parsed.meals;
    else competitorMeals = [];

    competitorMeals = competitorMeals.map(function (m) {

      function _fpNormList(val){
        if (val == null) return val;
        // If it's a JSON string like "[\"gid://...\"]", parse it
        if (typeof val === "string") {
          var t = val.trim();
          if (t.charAt(0) === "[") {
            try { return JSON.parse(t); } catch(e) { return val; }
          }
          return val;
        }
        // If it's an array with a single JSON-string element, flatten it
        if (Array.isArray(val) && val.length === 1 && typeof val[0] === "string") {
          var t0 = val[0].trim();
          if (t0.charAt(0) === "[") {
            try { return JSON.parse(t0); } catch(e) { return val; }
          }
        }
        return val;
      }
      if (!m || typeof m !== 'object') return m;
      if (!m.id && m.comparison_id) m.id = m.comparison_id;

      if (m.brand && typeof m.brand === 'object') {
        m.brand = m.brand.name || m.brand.title || m.brand.handle || m.brand.value || '';
      }

      // Normalise handles used for wet-equivalent matching
      if (!m.meal_type_handle) {
        if (m.meal_type && typeof m.meal_type === 'object') {
          m.meal_type_handle = m.meal_type.handle || m.meal_type.value || m.meal_type.title || '';
        } else {
          m.meal_type_handle = m.meal_type || '';
        }
      }
      if (!m.compares_to_fp_handle) {
        if (m.compares_to_what_fp_product && typeof m.compares_to_what_fp_product === 'object') {
          m.compares_to_fp_handle = m.compares_to_what_fp_product.handle ||
            (m.compares_to_what_fp_product.value && m.compares_to_what_fp_product.value.handle) ||
            '';
        } else {
          m.compares_to_fp_handle = m.compares_to_what_fp_product || '';
        }


// Ensure list-style compare fields are arrays (and de-stringify if needed)
m.compares_to_product_handles = _fpNormList(m.compares_to_product_handles);
m.compares_to_fp_product_handles = _fpNormList(m.compares_to_fp_product_handles);
      }

      if (!m.nutrition || typeof m.nutrition !== 'object') {
  var n = {};
  function mapRow(outKey, key100g, keyPouch) {
    var v100 = (key100g in m) ? m[key100g] : null;
    var vPou = (keyPouch in m) ? m[keyPouch] : null;
    n[outKey] = { per_100g: v100, regular: vPou, xl: null };
  }

  mapRow('energy_kcal',       'kcal_100g',                 'kcal_pouch');
  mapRow('fat_g',             'fat_100g',                  'fat_pouch');
  mapRow('saturates_g',       'of_which_saturates_100g',   'of_which_saturates_pouch');
  mapRow('carbohydrate_g',    'carbohydrate_100g',         'carbohydrate_pouch');
  mapRow('sugars_g',          'of_which_sugars_100g',      'of_which_sugars_pouch');
  mapRow('fibre_g',           'fibre_100g',                'fibre_pouch');
  mapRow('protein_g',         'protein_100g',              'protein_pouch');
  mapRow('salt_g',            'salt_100g',                 'salt_pouch');

  m.nutrition = n;
}

      return m;
    });

    return competitorMeals;
  }

  function loadFirepotHandles(panel) {
    var s = qs('script[data-fp-firepot-handles]', panel);
    var parsed = s ? safeParse(s.textContent || '') : null;
    return Array.isArray(parsed) ? parsed : [];
  }

  function getCompetitorById(competitors, id) {
    for (var i = 0; i < competitors.length; i++) {
      if (String(competitors[i].id || '') === String(id)) return competitors[i];
    }
    return null;
  }

  var cache = {};
  function convertVariantWeightToG(w, unit){
    var n = toNumber(w);
    if (n == null) return null;
    var u = String(unit||'').toLowerCase();
    if (u === 'kg') return n * 1000;
    if (u === 'g' || u === '') return n;
    if (u === 'lb' || u === 'lbs') return n * 453.592;
    if (u === 'oz') return n * 28.3495;
    return n;
  }

  async function fetchShopifyProductMeta(handle){
    var key = '__shopify_meta__' + handle;
    if (cache[key]) return cache[key];
    try{
      var r = await fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' });
      if (!r.ok) throw new Error('product.js ' + r.status);
      var pj = await r.json();
      var v = pj && pj.variants && pj.variants[0] ? pj.variants[0] : null;
      var price_gbp = (v && v.price != null) ? (toNumber(v.price) / 100.0) : null;
      var weight_g = null;
      if (v && v.weight != null) {
        var unit = (v.weight_unit || pj.weight_unit || '').toLowerCase();
        weight_g = convertVariantWeightToG(v.weight, unit);
      }
      cache[key] = { price_gbp: price_gbp, weight_g: weight_g };
      return cache[key];
    }catch(e){
      cache[key] = { price_gbp: null, weight_g: null };
      return cache[key];
    }
  }


  function normalizeProductPayload(payload) {
    return {
      handle: payload.handle,
      title: payload.title,
      url: payload.url || '',
      img: payload.img || '',
      tags: normTags(payload.tags),
      nutrition: payload.nutrition || {},
      weights: payload.weights || {},
      water: payload.water || {},
      ingredients: toText(payload.ingredients),
      allergens: toText(payload.allergens)
    };
  }

  function getCompetitorData(competitors, handle) {
    var id = handle.replace(/^comp:/, '');
    var m = getCompetitorById(competitors, id);
    if (!m) return null;

    return {
      handle: handle,
      title: (m.brand ? (m.brand + ' ') : '') + (m.product_name || m.title || id),
      url: '',
      img: (m.img || ''),
      tags: [],
      average_rrp_gbp: m.average_rrp_gbp || m.rrp_gbp || m.average_rrp || m.rrp || m.price_gbp || null,
      price_gbp: m.average_rrp_gbp || m.rrp_gbp || m.average_rrp || m.rrp || m.price_gbp || null,
      pouch_weight_g: m.pouch_weight_g || null,
      weights: { regular_g: toNumber(m.pouch_weight_g) || null, xl_g: null },
      water: { regular_ml: m.water_to_add_ml || null, xl_ml: null },
      ingredients: toText(m.ingredients),
      allergens: toText(m.allergens),
      nutrition: (m.nutrition || {})
    };
  }

  async function fetchProductCompareJson(handle) {
    if (cache[handle]) return cache[handle];
    var url = '/products/' + encodeURIComponent(handle) + '?view=fp_compare_json';
    var res = await fetch(url, { credentials: 'same-origin' });
    if (!res.ok) throw new Error('Compare JSON fetch failed ' + res.status + ' for ' + handle);
    var payload = await res.json();
    var norm = normalizeProductPayload(payload);

    // Ensure we have price + regular pouch weight for Firepot products
    try {
      var meta = await fetchShopifyProductMeta(handle);
      if (meta) {
        if (norm.price_gbp == null && meta.price_gbp != null) norm.price_gbp = meta.price_gbp;
        if (norm.weights && norm.weights.regular_g == null && meta.weight_g != null) norm.weights.regular_g = Math.round(meta.weight_g);
      }
    } catch (e) {}

    cache[handle] = norm;
    return cache[handle];
  }

  async function getData(competitors, handle) {
    if (!handle) return null;
    if (isCompetitor(handle)) return getCompetitorData(competitors, handle);

    // Firepot product: compare JSON + (optionally) Shopify product meta for price/weight
    var p = await fetchProductCompareJson(handle);

    try{
      var meta = await fetchShopifyProductMeta(handle);
      if (p) {
        // Price (GBP) for RRP row
        if (p.price_gbp == null && meta && meta.price_gbp != null) p.price_gbp = meta.price_gbp;

        // Pouch weight for "Pouch weight" row (regular mode expects pouch_weight_g)
        if (p.pouch_weight_g == null) {
          if (p.weights && p.weights.regular_g != null) p.pouch_weight_g = toNumber(p.weights.regular_g);
          else if (meta && meta.weight_g != null) p.pouch_weight_g = meta.weight_g;
        }
      }
    }catch(e){}

    return p;
  }

  function viewSubLabel(view, p) {
    if (!view) return '';
    if (view === 'nutri_100g') return 'Per 100g';
    if (view === 'nutri_regular') return 'Regular' + (p.weights && p.weights.regular_g ? (' (' + p.weights.regular_g + 'g)') : '');
    if (view === 'nutri_xl') return 'Extra Large' + (p.weights && p.weights.xl_g ? (' (' + p.weights.xl_g + 'g)') : '');
    return '';
  }

  function buildTableShell(state, products) {
    var html = '';
    html += '<table class="fp-compare__table"><colgroup>';
    html += '<col class="fp-compare__col-label">';
    for (var i = 0; i < CURRENT_MAX_COLS; i++) html += '<col class="fp-compare__col-prod">';
    html += '</colgroup><thead><tr>';
    html += '<th class="fp-compare__labelHead"></th>';

    for (var j = 0; j < CURRENT_MAX_COLS; j++) {
      var p = products[j];
      if (!p) {
        if (state && state.showMobileFirepotPicker && j === state.mobileFirepotPickerIndex && state.mobileFirepotPickerHtml) {
          html += '<th class="fp-compare__prodHead fp-compare__prodHead--picker" data-fp-mobile-firepot-picker-head>' + state.mobileFirepotPickerHtml + '</th>';
        } else {
          html += '<th class="fp-compare__prodHead"></th>';
        }
        continue;
      }

      html += '<th class="fp-compare__prodHead">';
      if (p.url) html += '<a class="fp-compare__prodTitle" href="' + p.url + '">' + escapeHtml(p.title) + '</a>';
      else html += '<span class="fp-compare__prodTitle">' + escapeHtml(p.title) + '</span>';

      html += '<div class="fp-compare__thumbWrap' + ((p && isCompetitor(p.handle)) ? ' fp-compare__thumbWrap--wet' : '') + '">';
      if (!(p && isCompetitor(p.handle)) && j !== 0) {
        html += '<button type="button" class="fp-compare__xbtn fp-compare__xbtn--inhead" data-fp-compare-x="' + j + '" aria-label="Remove">×</button>';
      }
      var thumbSrc = p.img;
      var thumbCls = 'fp-compare__thumb';
      if (p && isCompetitor(p.handle)) {
        thumbSrc = WET_POUCH_IMG;
        thumbCls += ' fp-compare__thumb--wet';
      }
      if (thumbSrc) html += '<img class="' + thumbCls + '" src="' + thumbSrc + '" alt="">';
      html += '</div>';

      html += '<div class="fp-compare__sub">' + escapeHtml(viewSubLabel(state.view, p)) + '</div>';
      html += '</th>';
    }

    html += '</tr></thead><tbody>';
    return html;
  }

  function renderNutrition(state, products, mode) {
    var html = buildTableShell(state, products);

    
    // Extra meta rows for Regular and Extra Large pouch comparisons (price + pouch weight)
    if (mode === 'nutri_regular' || mode === 'nutri_xl') {
      var weightKey = (mode === 'nutri_xl') ? 'xl_g' : 'regular_g';

      html += buildMetaRow('RRP', products, function (p, colIndex) {
        if (!p) return null;
        if (colIndex === 0) return CURRENT_PRICE_GBP;
        return toNumber(p.price_gbp != null ? p.price_gbp : (p.average_rrp_gbp != null ? p.average_rrp_gbp : p.average_rrp));
      }, 'money');

      html += buildMetaRow('Pouch weight', products, function (p, colIndex) {
        if (!p) return null;
        if (p.weights && p.weights[weightKey] != null) return toNumber(p.weights[weightKey]);
        if (mode === 'nutri_regular' && p.pouch_weight_g != null) return toNumber(p.pouch_weight_g);
        return null;
      }, 'g');

      // Visual gap before nutrient rows
      html += '<tr class="fp-compare__row fp-compare__row--gap"><td colspan="' + (CURRENT_MAX_COLS+1) + '"></td></tr>';
    }

NUTRI_ROWS.forEach(function (r) {
      html += '<tr>';
      html += '<th' + (r.indent ? ' class="fp-compare__indent"' : '') + '>' + escapeHtml(r.label) + '</th>';

      for (var j = 0; j < CURRENT_MAX_COLS; j++) {
        var p = products[j];
        if (!p) { html += '<td></td>'; continue; }

        var val = null;
        if (p.nutrition && p.nutrition[r.key] && typeof p.nutrition[r.key] === 'object') {
          if (mode === 'nutri_100g') val = p.nutrition[r.key].per_100g;
          if (mode === 'nutri_regular') val = p.nutrition[r.key].regular;
          if (mode === 'nutri_xl') val = p.nutrition[r.key].xl;
        } else if (r.alt && p.nutrition) {
          for (var a = 0; a < r.alt.length; a++) {
            var ak = r.alt[a];
            if (p.nutrition[ak] && typeof p.nutrition[ak] === 'object') {
              if (mode === 'nutri_100g') val = p.nutrition[ak].per_100g;
              if (mode === 'nutri_regular') val = p.nutrition[ak].regular;
              if (mode === 'nutri_xl') val = p.nutrition[ak].xl;
              if (val !== null && val !== undefined && val !== '') break;
            }
          }
        }

        html += '<td class="fp-compare__val">' + fmt(val, r.unit) + '</td>';
      }

      html += '</tr>';
    });

    html += '</tbody></table>';
    return html;
  }

  function renderWater(state, products) {
    var html = buildTableShell(state, products);

    function waterCell(p, which) {
      // Empty/unassigned columns should stay visually empty, not show dashes.
      if (!p) return '';
      var w = p.water || {};
      var weights = p.weights || {};

      if (which === 'reg_weight') return weights.regular_g ? String(weights.regular_g) + 'g' : '--';
      if (which === 'reg_water') return (w.regular_ml !== undefined && w.regular_ml !== null && w.regular_ml !== '') ? String(w.regular_ml) + 'ml' : '--';
      if (which === 'reg_rehyd') {
        var g = toNumber(weights.regular_g);
        var ml = toNumber(w.regular_ml);
        if (g === null || ml === null) return '--';
        return String(Math.round(g + ml)) + 'g';
      }

      if (which === 'xl_weight') return weights.xl_g ? String(weights.xl_g) + 'g' : '--';
      if (which === 'xl_water') return (w.xl_ml !== undefined && w.xl_ml !== null && w.xl_ml !== '') ? String(w.xl_ml) + 'ml' : '--';
      if (which === 'xl_rehyd') {
        var gx = toNumber(weights.xl_g);
        var mlx = toNumber(w.xl_ml);
        if (gx === null || mlx === null) return '--';
        return String(Math.round(gx + mlx)) + 'g';
      }
      return '--';
    }

    var rows = [
      { label: 'Regular meal weight', key: 'reg_weight' },
      { label: 'Regular meal water', key: 'reg_water' },
      { label: 'Rehydrated regular meal weight', key: 'reg_rehyd' },
      { spacer: true },
      { label: 'Extra Large meal weight', key: 'xl_weight' },
      { label: 'Extra Large meal water', key: 'xl_water' },
      { label: 'Rehydrated extra large meal weight', key: 'xl_rehyd' }
    ];

    rows.forEach(function (r) {
      if (r.spacer) {
        html += '<tr class="fp-compare__spacerRow"><th></th>';
        for (var j = 0; j < 6; j++) html += '<td></td>';
        html += '</tr>';
        return;
      }
      html += '<tr><th>' + escapeHtml(r.label) + '</th>';
      for (var j2 = 0; j2 < 6; j2++) {
        html += '<td class="fp-compare__val">' + escapeHtml(waterCell(products[j2], r.key)) + '</td>';
      }
      html += '</tr>';
    });

    html += '</tbody></table>';
    return html;
  }

  function renderIngredients(state, products) {
    var html = buildTableShell(state, products);
    html += '<tr><th>Ingredients</th>';
    for (var j = 0; j < CURRENT_MAX_COLS; j++) {
      var p = products[j];
      if (!p) {
        html += '<td class="fp-compare__textCell"></td>';
        continue;
      }
      var txt = toText(p.ingredients);
      html += '<td class="fp-compare__textCell">' + (txt ? escapeHtml(txt) : '--') + '</td>';
    }
    html += '</tr></tbody></table>';
    return html;
  }

  function renderAllergens(state, products) {
    var html = buildTableShell(state, products);

    function tick(ok) { return ok ? '✓' : ''; }

    html += '<tr><th>Vegan</th>';
    for (var j = 0; j < CURRENT_MAX_COLS; j++) {
      var p = products[j];
      var ok = p && !isCompetitor(p.handle) && hasTag(p.tags || [], 'vegan');
      html += '<td class="fp-compare__val fp-compare__tick">' + tick(ok) + '</td>';
    }
    html += '</tr>';

    html += '<tr><th>Gluten free</th>';
    for (var j2 = 0; j2 < 6; j2++) {
      var p2 = products[j2];
      var ok2 = p2 && !isCompetitor(p2.handle) && hasTag(p2.tags || [], 'glutenfree');
      html += '<td class="fp-compare__val fp-compare__tick">' + tick(ok2) + '</td>';
    }
    html += '</tr>';

    html += '<tr><th>Lactose free</th>';
    for (var j3 = 0; j3 < 6; j3++) {
      html += '<td class="fp-compare__val fp-compare__tick">' + (products[j3] ? '✓' : '') + '</td>';
    }
    html += '</tr>';

    html += '<tr><th>Allergens</th>';
    for (var j4 = 0; j4 < 6; j4++) {
      var p4 = products[j4];
      if (!p4) {
        html += '<td class="fp-compare__allergenCell"></td>';
        continue;
      }
      var txt4 = toText(p4.allergens);
      html += '<td class="fp-compare__allergenCell">' + (txt4 ? escapeHtml(txt4) : '--') + '</td>';
    }
    html += '</tr>';

    html += '</tbody></table>';
    return html;
  }


function bindCalcToggles(scope){
  var roots = (scope || document).querySelectorAll('[data-fp-product-compare-root]');
  if(!roots || !roots.length) return;

  roots.forEach(function(root){
    var factsBox = root.querySelector('.fp-compare__wetFacts.fp-compare__factsBox');
    if(!factsBox) return;

    var btn = factsBox.querySelector('.fp-compare__calcToggle');
    var main = factsBox.querySelector('.fp-compare__factsMain');
    var calc = factsBox.querySelector('.fp-compare__factsCalc');
    var backBtn = factsBox.querySelector('.fp-compare__calcBack');

    // We use ONE top-right toggle button; hide legacy back button if present

    function openCalc(){
      ensureClosedHeight();
      var h = parseFloat(factsBox.dataset.fpFactsClosedH || '0');
      if(h) factsBox.style.height = h + 'px';
      factsBox.classList.add('fp-compare__facts--calcOpen');
      main.hidden = true;
      calc.hidden = false;
      btn.setAttribute('aria-expanded','true');
      btn.textContent = '×';
    }

    function closeCalc(){
      factsBox.classList.remove('fp-compare__facts--calcOpen');
      calc.hidden = true;
      main.hidden = false;
      btn.setAttribute('aria-expanded','false');
      factsBox.style.height = '';
      btn.textContent = 'View calculations';
    }

    // initial
    factsBox.classList.remove('fp-compare__facts--calcOpen');
    btn.setAttribute('aria-expanded','false');
    btn.textContent = 'View calculations';
    calc.hidden = true;
    main.hidden = false;
    factsBox.style.height = '';

    if(!btn.dataset.fpBound){
      btn.dataset.fpBound = '1';
      btn.addEventListener('click', function(e){
        e.preventDefault();
        if(factsBox.classList.contains('fp-compare__facts--calcOpen')){
          closeCalc();
        } else {
          openCalc();
        }
      });
    }
    if(backBtn && !backBtn.dataset.fpBound){
      backBtn.dataset.fpBound = '1';
      backBtn.addEventListener('click', function(e){
        e.preventDefault();
        closeCalc();
      });
    }

    if(!factsBox.dataset.fpEscBound){
      factsBox.dataset.fpEscBound = '1';
      document.addEventListener('keydown', function(e){
        if(e.key === 'Escape' && factsBox.classList.contains('fp-compare__facts--calcOpen')){
          closeCalc();
        }
      });
    }

    setTimeout(ensureClosedHeight, 50);
    setTimeout(ensureClosedHeight, 300);
  });
}

// Robust event delegation for calc toggle/close (survives re-renders)
// IMPORTANT: markup in wet compare is:
//   .fp-compare__wetFacts
//     .fp-compare__factsBox   (pouches + summary + button)
//     .fp-compare__factsCalc  (hidden)
// So we toggle factsBox <-> factsCalc and keep the container height fixed so
// the module doesn't grow downward when showing calculations.
function ensureWetFactsCalcToggle(root){
  // Robust click handling for the wet facts toggle.
  // Fixes cases where the button appears but does nothing (no bind / re-render / overlay).
  // Behaviour unchanged: we simply swap summary <-> calculations inside the SAME grey box.
  if(!root || root.__fpWetFactsCalcDelegated) return;
  root.__fpWetFactsCalcDelegated = true;

  function getLabel(btn, which){
    if(!btn) return which === 'open' ? 'View summary' : 'See the calculations';
    var attr = which === 'open' ? 'data-fp-calc-label-open' : 'data-fp-calc-label-closed';
    return (btn.getAttribute(attr) || btn.getAttribute(attr.replace('data-','')) || '').trim() ||
      (which === 'open' ? 'View summary' : 'See the calculations');
  }

  function setState(factsBox, btn, open){
    if(!factsBox) return;

    var summary = factsBox.querySelector('[data-fp-wet-summary]') || factsBox.querySelector('.fp-compare__wetSummary');
    var calcs   = factsBox.querySelector('[data-fp-wet-calcs]')   || factsBox.querySelector('.fp-compare__wetCalcs');

    if(summary) summary.hidden = !!open;
    if(calcs)   calcs.hidden   = !open;

    factsBox.classList.toggle('fp-compare__factsBox--calcOpen', !!open);

    if(btn){
      btn.textContent = open ? getLabel(btn,'open') : getLabel(btn,'closed');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      btn.setAttribute('aria-label', open ? getLabel(btn,'open') : getLabel(btn,'closed'));
      btn.setAttribute('title', open ? getLabel(btn,'open') : getLabel(btn,'closed'));
    }
  }

  // On each render, force initial state to "closed" for any new factsBox.
  function initBoxes(){
    try{
      (root.querySelectorAll('.fp-compare__wetFacts .fp-compare__factsBox') || []).forEach(function(factsBox){
        var btn = factsBox.querySelector('.fp-compare__calcToggle');
        if(!btn){
          // Defensive: if markup ever changes and the button is missing, create it.
          btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'fp-compare__calcToggle';
          factsBox.appendChild(btn);
        }
        // Hide legacy back button (we don't use it in this mode)
        var legacyBack = factsBox.querySelector('.fp-compare__calcBack');
        if(legacyBack) legacyBack.hidden = true;

        // If already initialised, do nothing.
        if(btn.dataset.fpInitStateDone) return;
        btn.dataset.fpInitStateDone = '1';

        setState(factsBox, btn, false);
      });
    }catch(e){}
  }

  initBoxes();
  setTimeout(initBoxes, 50);
  setTimeout(initBoxes, 250);

  // Delegated click: survives innerHTML swaps.
  root.addEventListener('click', function(e){
    var btn = e.target && e.target.closest ? e.target.closest('.fp-compare__calcToggle') : null;
    if(!btn) return;

    var factsBox = btn.closest('.fp-compare__factsBox');
    if(!factsBox) return;

    e.preventDefault();
    e.stopPropagation();

    var isOpen = factsBox.classList.contains('fp-compare__factsBox--calcOpen');
    setState(factsBox, btn, !isOpen);
  }, true);
}




function bindTableButtons(wrap, removeAt) {
    qsa('[data-fp-compare-x]', wrap).forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        removeAt(parseInt(btn.getAttribute('data-fp-compare-x'), 10));
      });
    });
  }

  function initOne(root) {
    var panel = qs('[data-fp-compare]', root);
    if (!panel || panel.__fpInit) return;
    panel.__fpInit = true;

    var currentHandle = root.getAttribute('data-fp-current-handle');
    var currentProductId = root.getAttribute('data-fp-current-product-id');
    var currentProductId = root.getAttribute('data-fp-current-product-id');
        CURRENT_PRICE_GBP = toNumber(root.getAttribute('data-fp-current-price-gbp'));
var currentVariantId = null; // no longer used (product ref mapping)
    if (!currentHandle) return;

    var state = makeState();
    var wrap = qs('[data-fp-compare-wrap]', panel);
    var topBar = qs('.fp-compare__top', panel);

    var clearBtn = qs('[data-fp-compare-clear]', panel);
    var printBtn = qs('[data-fp-compare-print]', panel);

    var msgEl = qs('[data-fp-compare-msg]', panel);
    function setMsg(t) { if (msgEl) msgEl.textContent = t || ''; }

    var competitors = loadCompetitors(panel);
    var firepot = loadFirepotHandles(panel);

    function refreshDataCaches(){
      try{
        // If tab content was lazy-inserted, these may have been empty at init time
        if ((!competitors || !competitors.length) && panel.querySelector('[data-fp-compare-competitors]')) {
          competitors = loadCompetitors(panel);
        }
        if ((!firepot || !firepot.length) && panel.querySelector('[data-fp-firepot-handles]')) {
          firepot = loadFirepotHandles(panel);
        }
      }catch(e){}
    }

    // -------------------------------------------------------------
    // FP FP_COMPARE_DEBUG (opt-in): add ?fp_compare_debug=1
    // -------------------------------------------------------------
    var debugOn = false;
    try {
      debugOn = new URLSearchParams(window.location.search).get('fp_compare_debug') === '1';
    } catch (e) {}

    function dbg() {
      if (!debugOn) return;
      try {
        console.log.apply(console, ['FP COMPARE FP_COMPARE_DEBUG:'].concat([].slice.call(arguments)));
      } catch (e) {}
    }

    function ensureDebugPanel() {
      if (!debugOn) return null;
      try {
        var existing = root.querySelector('[data-fp-compare-debug-panel]');
        if (existing) return existing;
        var d = document.createElement('div');
        d.setAttribute('data-fp-compare-debug-panel', '');
        d.style.cssText = 'margin:10px 0;padding:10px;border:1px solid #ccc;background:#fff8c5;font-size:12px;line-height:1.4;white-space:pre-wrap;';
        d.textContent = 'FP COMPARE FP_COMPARE_DEBUG (add ?fp_compare_debug=1)';
        // Insert near the top of the module
        var top = root.querySelector('.fp-compare__top');
        if (top && top.parentNode) top.parentNode.insertBefore(d, top.nextSibling);
        else root.insertBefore(d, root.firstChild);
        return d;
      } catch (e) {
        return null;
      }
    }

    function anyEq(listOrVal, target) {
      if (target === undefined || target === null || target === '') return false;

      // Normalise:
      // - For IDs, Shopify sometimes gives numbers, strings, or gid://shopify/ProductVariant/123…
      // - For handles, case/whitespace differences can occur.
      var tRaw = String(target);
      var tDigits = tRaw.replace(/\D/g, '');
      var useDigits = tDigits && tDigits.length >= 6; // variant ids are long numbers

      function eqOne(v) {
        var s = String(v === undefined || v === null ? '' : v);
        if (useDigits) return s.replace(/\D/g, '') === tDigits;
        return s.trim().toLowerCase() === tRaw.trim().toLowerCase();
      }

      if (Array.isArray(listOrVal)) {
        for (var i = 0; i < listOrVal.length; i++) {
          if (eqOne(listOrVal[i])) return true;
        }
        return false;
      }
      return eqOne(listOrVal);
    }


    function normType(v) {
      // metaobject value might be 'Wet', 'wet', 'WET', etc.
      return String(v || '').trim().toLowerCase();
    }

    function getWetMatches() {
      return (competitors || []).filter(function (m) {
        var typeOk = normType(m.meal_type_handle) === 'wet';

        // ✅ NEW approach (metaobject list of Products):
        //   compares_to_product_handles (array of handles)
        //   compares_to_product_handle  (single handle, just in case)
        // Legacy keys we still accept:
        //   compares_to_fp_product_handles / compares_to_fp_product_handle
        var byProd = anyEq(
          m.compares_to_product_handles || m.compares_to_product_handle ||
          m.compares_to_fp_product_handles || m.compares_to_fp_product_handle,
          (currentProductId || currentHandle)
        );

        // legacy fallback (older attempts)
        var byLegacy = String(m.compares_to_fp_handle || '') === String(currentHandle);

        return typeOk && (byProd || byLegacy);
      }).sort(function (a, b) {
        var ak = (String(a.brand || '') + ' ' + String(a.product_name || a.title || '')).toLowerCase();
        var bk = (String(b.brand || '') + ' ' + String(b.product_name || b.title || '')).toLowerCase();
        if (ak < bk) return -1;
        if (ak > bk) return 1;
        return 0;
      });
    }

    // Debug dump (safe, optional)
    if (debugOn) {
      var dp = ensureDebugPanel();
      dbg('currentHandle:', currentHandle);
      dbg('currentVariantId:', currentVariantId);
      dbg('competitors loaded:', (competitors || []).length);
      try {
        // Extra: dump the raw compares_to arrays/values so you don't have to expand objects manually.
        // This is the most common failure point when metaobject fields are variant lists.
        var first = (competitors || [])[0];
        if (first) {
          // NEW metaobject field (list of Products): compares_to_product / compares_to_product_handles
          // Legacy fields kept for backward compatibility.
          var rawPH =
            first.compares_to_product_handles || first.compares_to_product_handle ||
            first.compares_to_fp_product_handles || first.compares_to_fp_product_handle;
          var rawVI = first.compares_to_fp_variant_ids || first.compares_to_fp_variant_id;
          dbg('first competitor id:', first.id || first.comparison_id);
          dbg('first competitor meal_type_handle:', first.meal_type_handle);
          dbg('first competitor compares_to handles:', rawPH);
          dbg('first competitor compares_to_fp_variant_ids:', rawVI);
          // Normalised forms
          try {
            var normPH = Array.isArray(rawPH) ? rawPH.map(function(x){ return String(x||'').trim().toLowerCase(); }) : String(rawPH||'').trim().toLowerCase();
            var normVI = Array.isArray(rawVI) ? rawVI.map(function(x){ return String(x||'').replace(/\D/g,''); }) : String(rawVI||'').replace(/\D/g,'');
            dbg('first competitor norm product handles:', normPH);
            dbg('first competitor norm variant ids:', normVI);
          } catch (e) {}
        }
        var rows = (competitors || []).slice(0, 25).map(function (m) {
          var type = normType(m.meal_type_handle);
          var byProd = anyEq(m.compares_to_fp_product_handles || m.compares_to_fp_product_handle, currentHandle);
          var byVar = currentVariantId && anyEq(m.compares_to_fp_variant_ids || m.compares_to_fp_variant_id, currentVariantId);
          var byLegacy = String(m.compares_to_fp_handle || '') === String(currentHandle);
          return {
            id: m.id || m.comparison_id,
            meal_type_handle: m.meal_type_handle,
            norm_type: type,
            compares_to_fp_product_handles: m.compares_to_fp_product_handles || m.compares_to_fp_product_handle,
            compares_to_fp_variant_ids: m.compares_to_fp_variant_ids || m.compares_to_fp_variant_id,
            byProd: byProd ? 'Y' : 'N',
            byVar: byVar ? 'Y' : 'N',
            byLegacy: byLegacy ? 'Y' : 'N'
          };
        });
        console.table(rows);
        var wetCount = getWetMatches().length;
        dbg('wet matches:', wetCount);
        if (dp) {
          dp.textContent = [
            'FP COMPARE FP_COMPARE_DEBUG',
            'currentHandle: ' + currentHandle,
            'currentVariantId: ' + currentVariantId,
            'competitors loaded: ' + (competitors || []).length,
            'wet matches: ' + wetCount,
            '',
            (first ? ('first competitor compares_to handles: ' + JSON.stringify(
              first.compares_to_product_handles || first.compares_to_product_handle ||
              first.compares_to_fp_product_handles || first.compares_to_fp_product_handle
            )) : ''),
            (first ? ('first competitor compares_to variant ids (legacy): ' + JSON.stringify(first.compares_to_fp_variant_ids || first.compares_to_fp_variant_id)) : ''),
            '',
            'Tip: open console.table to see compares_to arrays/ids.'
          ].join('\n');
        }
      } catch (e) {
        dbg('debug dump failed', e);
        if (dp) dp.textContent = 'FP COMPARE FP_COMPARE_DEBUG failed: ' + (e && e.message ? e.message : String(e));
      }
    }

    // Controls (Compare with + Choose meals + Compare for)
    var topBar = qs('.fp-compare__top', panel);
    var compareWithEl = qs('[data-fp-compare-with]', panel);
    var compareWithLabelEl = topBar ? (qs('[data-fp-compare-with-label]', topBar) || qs('.fp-compare__topLabel', topBar) || (compareWithEl ? compareWithEl.previousElementSibling : null)) : null;
    if (compareWithLabelEl && !compareWithLabelEl.hasAttribute('data-fp-compare-with-label')) {
      compareWithLabelEl.setAttribute('data-fp-compare-with-label', '');
    }
    var forTextEl = qs('[data-fp-compare-for]', panel);

    // View dropdown (compare for)
    var viewEl = qs('[data-fp-compare-view]', panel);
    if (!viewEl) {
      viewEl = document.createElement('select');
      viewEl.className = 'fp-compare__viewSelect';
      viewEl.setAttribute('data-fp-compare-view', '');
      if (topBar) topBar.appendChild(viewEl);
    }

    // Default: wet equivalent (if available), else Firepot compare
    var wetMatchesCount = getWetMatches().length;
    var hasWetMatches = wetMatchesCount > 0;

    function syncNoWetControlText() {
      if (!compareWithLabelEl) return;
      if (hasWetMatches) {
        compareWithLabelEl.textContent = 'Compare with:';
      } else if (isProductCompareMobile()) {
        compareWithLabelEl.textContent = 'Compare with another Firepot meal for:';
      } else {
        compareWithLabelEl.textContent = 'Compare with other Firepot meals:';
      }
    }

    syncNoWetControlText();
    window.addEventListener('resize', syncNoWetControlText);

    // Populate compare-with dropdown.
    // If there is no wet equivalent, hide this mode selector completely:
    // the Firepot meal picker becomes the "Compare with" dropdown instead.
    if (compareWithEl && !compareWithEl.__fpBound) {
      compareWithEl.__fpBound = true;
      compareWithEl.innerHTML = '';

      if (hasWetMatches) {
        var optWet = document.createElement('option');
        optWet.value = 'wet';
        optWet.textContent = 'Wet meal equivalent';
        compareWithEl.appendChild(optWet);

        var optFp = document.createElement('option');
        optFp.value = 'firepot';
        optFp.textContent = isProductCompareMobile() ? 'Another Firepot meal' : 'Other Firepot meals';
        compareWithEl.appendChild(optFp);
      } else {
        compareWithEl.hidden = true;
        compareWithEl.setAttribute('aria-hidden', 'true');
      }

      compareWithEl.addEventListener('change', function () {
        state.mode = this.value || 'firepot';
        // Reset view defaults per mode
        if (state.mode === 'wet') {
          state.view = 'compare_wet';
          panel.classList.add('fp-compare--expanded');
        } else {
          state.view = state.view && state.view !== 'compare_wet' ? state.view : 'nutri_regular';
          panel.classList.add('fp-compare--expanded');
        }
        render();
      });
    }

    // Build view options (Firepot mode only)
    function buildViewOptions() {
      if (!viewEl) return;
      viewEl.innerHTML = '';

      var opts = [
        { v: 'nutri_regular', t: 'Nutritional Values (Regular)' },
        { v: 'nutri_xl', t: 'Nutritional Values (Extra Large)' },
        { v: 'nutri_100g', t: 'Nutritional Values (100g)' },
        { v: 'water', t: 'Water usage' },
        { v: 'ingredients', t: 'Ingredients' },
        { v: 'allergens', t: 'Allergens' }
      ];

      opts.forEach(function (o) {
        var opt = document.createElement('option');
        opt.value = o.v;
        opt.textContent = o.t;
        viewEl.appendChild(opt);
      });

      if (!state.view || state.view === 'compare_wet') state.view = 'nutri_regular';
      viewEl.value = state.view;
    }

    if (viewEl && !viewEl.__fpBound) {
      viewEl.__fpBound = true;
      viewEl.addEventListener('change', function () {
        state.view = this.value || 'nutri_regular';
        panel.classList.add('fp-compare--expanded');
        render();
      });
    }

    // Ensure defaults on load
    state.mode = state.mode || (hasWetMatches ? 'wet' : 'firepot');
    if (state.mode === 'wet') {
      state.view = 'compare_wet';
    } else if (!state.view || state.view === 'compare_wet') {
      state.view = 'nutri_regular';
    }
    if (compareWithEl) compareWithEl.value = state.mode;

    // Make sure expanded by default
    panel.classList.add('fp-compare--expanded');

    // Grab meal select
    var mealSelect = qs('[data-fp-compare-meal-select]', panel);

    // Keep the view options in sync with mode
    buildViewOptions();


    function buildCombinedDropdown() {
      if (!mealSelect) return;


      var chosen = mealSelect.value || '';
      // Only visible/enabled in Firepot mode
      var isWetMode = (state.mode === 'wet');
      mealSelect.disabled = isWetMode;
      mealSelect.hidden = isWetMode;
      if (forTextEl) forTextEl.hidden = isWetMode;
      if (viewEl) viewEl.hidden = isWetMode;

      if (!hasWetMatches && compareWithEl) {
        compareWithEl.hidden = true;
        compareWithEl.setAttribute('aria-hidden', 'true');
      }

      mealSelect.innerHTML = '';

      function addOpt(value, text, disabled) {
        var opt = document.createElement('option');
        opt.value = value;
        opt.textContent = text;
        if (disabled) opt.disabled = true;
        mealSelect.appendChild(opt);
      }

      addOpt('', (!hasWetMatches ? (isProductCompareMobile() ? 'Choose a Firepot' : 'Choose Firepot meals') : 'Choose Firepot meals to compare'), false);


      // In wet-equivalent mode, disable the meal dropdown (competitors are auto-filled)
      if (state.mode === 'wet') {
        mealSelect.disabled = true;
        return;
      } else {
        mealSelect.disabled = false;
      }

      // Build a set of "blocked" handles (current + already selected)
      var blocked = {};
      blocked[currentHandle] = true;
      state.selected.forEach(function (h) { blocked[h] = true; });

      function labelWithTick(label, isBlocked){
        return isBlocked ? ('✓ ' + label) : label;
      }

      // Firepot
      firepot.forEach(function (p) {
        if (!p || !p.handle) return;
        var h2 = String(p.handle);
        var label2 = p.title ? String(p.title) : h2;
        var isBlocked = !!blocked[h2];
        addOpt(h2, labelWithTick(label2, isBlocked), isBlocked);
      });

      // restore previous value if it still exists
      mealSelect.value = chosen;
      if (!mealSelect.value) mealSelect.value = '';
    }

    function buildMobileFirepotPickerHtml() {
      var blocked = {};
      blocked[currentHandle] = true;
      state.selected.forEach(function (h) { blocked[h] = true; });

      var html = '<div class="fp-compare__mobilePicker" data-fp-mobile-firepot-picker-wrap>';
      html += '<select class="fp-compare__viewSelect fp-compare__mobilePickerSelect" data-fp-mobile-firepot-picker aria-label="Choose a Firepot meal">';
      html += '<option value="">Choose a Firepot</option>';

      firepot.forEach(function (p) {
        if (!p || !p.handle) return;
        var h = String(p.handle);
        var title = p.title ? String(p.title) : h;
        var isBlocked = !!blocked[h];
        html += '<option value="' + escapeHtml(h) + '"' + (isBlocked ? ' disabled' : '') + '>' +
          escapeHtml(isBlocked ? ('✓ ' + title) : title) +
          '</option>';
      });

      html += '</select></div>';
      return html;
    }

    function addHandle(handle) {
      if (state.view === 'compare_wet') {
        setMsg('Switch to Other Firepot meals to add Firepot meals.');
        return;
      }
      if (!handle) return;

      if (!isCompetitor(handle) && handle === currentHandle) {
        setMsg('That is the current product.');
        return;
      }
      if (state.mode === 'wet') {
        setMsg('');
        return;
      }
      if (state.selected.indexOf(handle) >= 0) {
        setMsg('Already added.');
        return;
      }
      var addLimit = isProductCompareMobile() ? 1 : (state.maxCols - 1);
      if (state.selected.length >= addLimit) {
        setMsg(isProductCompareMobile() ? 'Remove the selected Firepot meal before choosing another.' : 'We can only compare five Firepot meals. Remove one before adding another');
        return;
      }

      state.selected.push(handle);
      setMsg('');
      render();
    }

    function removeAt(colIndex) {
      if (colIndex <= 0) return;
      var idx = colIndex - 1;
      if (!state.selected[idx]) return;
      state.selected.splice(idx, 1);
      if (state.selected.length < (state.maxCols - 1)) setMsg('');
      render();
    }

    // Auto-add on change
    if (mealSelect && !mealSelect.__fpBound) {
      mealSelect.__fpBound = true;
      mealSelect.addEventListener('change', function () {
        var h = this.value || '';
        if (!h) return;
        // reset back to placeholder immediately (so you can add multiple quickly)
        this.value = '';
        addHandle(h);
      });
    }

    if (!panel.__fpMobileFirepotPickerBound) {
      panel.__fpMobileFirepotPickerBound = true;
      panel.addEventListener('change', function (e) {
        var t = e.target;
        if (!t || !t.matches || !t.matches('[data-fp-mobile-firepot-picker]')) return;
        var h = t.value || '';
        if (!h) return;
        t.value = '';
        addHandle(h);
      });
    }

    if (clearBtn) {
      clearBtn.addEventListener('click', function () {
        state.selected = [];
        state.view = '';
        viewEl.value = '';
        panel.classList.remove('fp-compare--expanded');
        setMsg('');
        render();
      });
    }

    if (printBtn) {
      printBtn.addEventListener('click', function () {
        window.print();
      });
    }

  function buildWetFactsHtml(products) {
      function fmtPriceDelta(deltaGbp){
        var d = toNumber(deltaGbp);
        if (d == null) return null;
        var abs = Math.abs(d);
        if (abs < 1) {
          var p = Math.round(abs * 100);
          return String(p) + 'p';
        }
        return '£' + abs.toFixed(2);
      }
      function fmtTimes(x){
        var v = toNumber(x);
        if (v == null) return null;
        var rInt = Math.round(v);
        if (Math.abs(v - rInt) < 0.05) return String(rInt);
        return String(Math.round(v * 10) / 10);
      }

      // ----------------------------------------------------
      // FP_COMPARE_DEBUG: show exactly which inputs are missing for facts
      // Enable with ?fp_compare_debug=1
      // ----------------------------------------------------
      if (FP_COMPARE_DEBUG) {
        try {
          var fpDbg = products && products[0] ? products[0] : null;
          var wetDbg = null;
          for (var wi = 0; wi < (products ? products.length : 0); wi++) {
            var pp = products[wi];
            if (pp && pp.handle && String(pp.handle).indexOf('comp:') === 0) { wetDbg = pp; break; }
          }

          console.group('FP COMPARE FACTS FP_COMPARE_DEBUG');
          console.log('Firepot product object:', fpDbg);
          console.log('Wet competitor object:', wetDbg);

          console.log('Firepot values:', {
                        CURRENT_PRICE_GBP: (typeof CURRENT_PRICE_GBP !== 'undefined') ? CURRENT_PRICE_GBP : null,
            kcal_regular: fpDbg && fpDbg.nutrition && fpDbg.nutrition.energy_kcal && fpDbg.nutrition.energy_kcal.regular,
            weight_g_regular: fpDbg && fpDbg.weights && fpDbg.weights.regular_g
          });

          console.log('Wet values:', {
            price_gbp: wetDbg && (wetDbg.price_gbp != null ? wetDbg.price_gbp : wetDbg.average_rrp_gbp),
            kcal_regular: wetDbg && wetDbg.nutrition && wetDbg.nutrition.energy_kcal && wetDbg.nutrition.energy_kcal.regular,
            weight_g_regular: wetDbg && wetDbg.weights && wetDbg.weights.regular_g
          });

          console.groupEnd();
        } catch (e) {
          console.warn('FP COMPARE FACTS FP_COMPARE_DEBUG failed:', e);
        }
      }

    var fp = products[0];
    var wet = products[1];

      var wetBrandRaw = (wet && (wet.brand || wet.vendor || wet.vendor_name || wet.id)) ? String(wet.brand || wet.vendor || wet.vendor_name || wet.id) : 'Wayfayrer';
      var wetBrand = normalizeCompetitorName(wetBrandRaw);
    if (!fp || !wet) return '';

    var fpKcal = toNumber(fp.nutrition && fp.nutrition.energy_kcal && fp.nutrition.energy_kcal.regular);
    var wetKcal = toNumber(wet.kcal_pouch) || toNumber(wet.nutrition && wet.nutrition.energy_kcal && wet.nutrition.energy_kcal.regular);
    var fpW = toNumber(fp.weights && fp.weights.regular_g);
    var wetW = toNumber(wet.pouch_weight_g);

      var fpWaterMl = null;
    function parseMl(v){
      if (v == null) return null;
      if (typeof v === 'number') return toNumber(v);
      var s = String(v).toLowerCase();
      var n = parseFloat(s.replace(/[^0-9.]/g,''));
      if (!isFinite(n)) return null;
      // if value looks like litres (e.g. "0.4l"), convert
      if (s.indexOf('l') !== -1 && s.indexOf('ml') === -1) return n * 1000;
      return n;
    }
    if (fp) {
      // Firepot JSON: water.regular_ml is standard
      if (fp.water && fp.water.regular_ml != null) fpWaterMl = parseMl(fp.water.regular_ml);
      else if (fp.water && fp.water.regular != null) fpWaterMl = parseMl(fp.water.regular);
      else if (fp.water && fp.water.xl_ml != null) fpWaterMl = parseMl(fp.water.xl_ml);
      else if (fp.water_regular_ml != null) fpWaterMl = parseMl(fp.water_regular_ml);
      else if (fp.water_ml != null) fpWaterMl = parseMl(fp.water_ml);
      else if (fp.water_l != null) fpWaterMl = parseMl(fp.water_l);
      else if (fp.water_to_add_ml != null) fpWaterMl = parseMl(fp.water_to_add_ml);
      else if (fp.water != null) fpWaterMl = parseMl(fp.water);
      // Fallback: if JSON is missing water, allow Liquid to pass it via data attribute
      if (fpWaterMl == null && root && root.dataset && root.dataset.fpCurrentWaterMl) fpWaterMl = parseMl(root.dataset.fpCurrentWaterMl);
}
var fpFinishedG = (fpW != null && fpWaterMl != null) ? (fpW + fpWaterMl) : null;
      var rehydPctMore = (fpFinishedG != null && wetW != null && wetW > 0) ? ((fpFinishedG / wetW) - 1) * 100.0 : null;
      var fpFinishedText = (fpFinishedG != null) ? (Math.round(fpFinishedG) + 'g') : '—';
      var rehydPctText = (rehydPctMore != null) ? (Math.round(rehydPctMore) + '%') : '—';
    var fpPrice = CURRENT_PRICE_GBP;
    var wetPrice = toNumber(wet.average_rrp_gbp);

    if ([fpKcal, wetKcal, fpW, wetW, fpPrice, wetPrice].some(function(x){ return x===null || x===undefined; })) {
      return '<div class="fp-compare__factsBox"><div class="fp-compare__factsTitle">How do we compare?</div><div class="fp-compare__factsBody">Facts unavailable missing price, kcal or weight.' + (FP_COMPARE_DEBUG ? ('<div style="margin-top:8px;font-size:12px;opacity:.75;">' +
          'FP price: ' + (CURRENT_PRICE_GBP != null ? CURRENT_PRICE_GBP : 'null') + ', ' +
          'FP kcal: ' + (fpKcal != null ? fpKcal : 'null') + ', ' +
          'FP g: ' + (fpW != null ? fpW : 'null') + '<br>' +
          'Wet price: ' + (wetPrice != null ? wetPrice : 'null') + ', ' +
          'Wet kcal: ' + (wetKcal != null ? wetKcal : 'null') + ', ' +
          'Wet g: ' + (wetW != null ? wetW : 'null') +
        '</div>') : '') + '</div></div>';
    }

    var fpPpk = fpPrice / fpKcal;
    var wetPpk = wetPrice / wetKcal;
    var costRatio = wetPpk / fpPpk;

    // Percent cheaper per calorie (Firepot vs wet baseline)
    var pctCheaper = (wetPpk > 0) ? ((wetPpk - fpPpk) / wetPpk) * 100.0 : null;
    var pctCheaperText = (pctCheaper == null) ? '—' : (Math.round(pctCheaper) + '%');

    var fpCpg = fpKcal / fpW;
    var wetCpg = wetKcal / wetW;
    var cpgRatio = fpCpg / wetCpg;

    var wetPouches = fpKcal / wetKcal;
    var extraCost = (wetPouches * wetPrice) - fpPrice;
    var extraWeightG = (wetPouches * wetW) - fpW;

    var wkExtraCost = extraCost * 4;
    var wkExtraWeightKg = (extraWeightG * 4) / 1000;

    // Rehydrated Firepot weight (dry g + water ml)
    var fpWaterMl = toNumber(fp && (fp.water_ml != null ? fp.water_ml : (fp.water != null ? fp.water : (fp.water_l != null ? fp.water_l * 1000 : null))));
    if ((fpWaterMl == null || isNaN(fpWaterMl)) && root && root.dataset && root.dataset.fpCurrentWaterMl) fpWaterMl = toNumber(root.dataset.fpCurrentWaterMl);
    var fpFinishedG = (fpW != null && fpWaterMl != null) ? (fpW + fpWaterMl) : null;
    var rehydPctMore = (fpFinishedG != null && wetW != null && wetW > 0) ? ((fpFinishedG / wetW) - 1) * 100.0 : null;
    var fpFinishedText = (fpFinishedG != null) ? (Math.round(fpFinishedG) + 'g') : '—';
    var rehydPctText = (rehydPctMore != null) ? (Math.round(rehydPctMore) + '%') : '—';


    function moneyDiffText(x) {
      var sign = x >= 0 ? 'more' : 'less';
      var abs = Math.abs(x);
      if (abs < 1) return fmtPriceDelta(abs) + ' ' + sign;
      return fmtPriceDelta(abs) + ' ' + sign;
    }
    function weightDiffTextG(x) {
      var sign = x >= 0 ? 'more' : 'less';
      return (Math.round(Math.abs(x)) + 'g') + ' ' + sign;
    }
    function weightDiffTextKg(x) {
      var sign = x >= 0 ? 'more' : 'less';
      return fmtKg(Math.abs(x)) + ' ' + sign;
    }

    var wetBrandRaw = (wet.brand ? wet.brand : 'Wayfayrer');
    var wetTitleRaw = (wet.product_name || wet.title || wet.id || '');
    var wetBrand = normalizeCompetitorName(wetBrandRaw);
    var wetFull = normalizeCompetitorName((wetBrand + ' ' + wetTitleRaw).trim());
    var wetName = wetBrand;

    // Wording rules
    var timesPhrase = (cpgRatio > 4.05) ? 'more than 4' : fmtTimes(cpgRatio);
    var line1 = 'Firepot has <strong>' + timesPhrase + '</strong> times more calories per gramme by weight. Each Firepot calorie costs you <strong>' + pctCheaperText + '</strong> less than the equivalent calorie from <strong>' + wetName + '</strong>.';

    var lineRehyd = 'Once rehydrated this Firepot meal weighs <strong>' + fpFinishedText + '</strong> that is <strong>' + rehydPctText + '</strong> more than the <strong>' + wetName + '</strong> equivalent.';

    // --- Pouch graphic (fills row). Shows: 1 Firepot = 1 full wet + optional partial wet.
    function buildPouchGraphic(){
      var x = toNumber(wetPouches);
      if (x == null || !isFinite(x) || x <= 0) return '';
      var full = Math.floor(x);
      var frac = x - full;
      var fracPct = Math.max(0, Math.min(1, frac));
      if (fracPct < 0.06) fracPct = 0;

      var fpImg = 'https://cdn.shopify.com/s/files/1/1596/8375/files/fp.png?v=1769611102';
      var wetImg = 'https://cdn.shopify.com/s/files/1/1596/8375/files/sample-pouch.png?v=1777884599';

      var html = '';
      html += '<div class="fp-compare__pouchEqGraphic" aria-label="Pouch equivalence">';
        html += '<div class="fp-compare__pouchEqCol fp-compare__pouchEqCol--fp">';
          html += '<div class="fp-compare__pouchEqPouch fp-compare__pouchEqPouch--fp">';
            html += '<img class="fp-compare__pouchEqImg" src="' + fpImg + '" alt="Firepot pouch">';
          html += '</div>';
        html += '</div>';

        html += '<div class="fp-compare__pouchEqMid">=</div>';

        html += '<div class="fp-compare__pouchEqCol fp-compare__pouchEqCol--wet">';          html += '<div class="fp-compare__pouchEqStack">';
            html += '<div class="fp-compare__pouchEqPouch fp-compare__pouchEqPouch--wet">';
              html += '<img class="fp-compare__pouchEqImg" src="' + wetImg + '" alt="' + escapeHtml(wetName) + ' pouch">';
            html += '</div>';

            if (fracPct > 0) {
              html += '<div class="fp-compare__pouchEqPouch fp-compare__pouchEqPouch--wet fp-compare__pouchEqPouch--partial" style="--fp-part:' + Math.round(fracPct*100) + ';">' +
                        '<div class="fp-compare__pouchEqCrop">' +
                          '<img class="fp-compare__pouchEqImg" src="' + wetImg + '" alt="' + escapeHtml(wetName) + ' pouch">' +
                        '</div>' +
                      '</div>';
            } else if (full >= 2) {
              html += '<div class="fp-compare__pouchEqPouch fp-compare__pouchEqPouch--wet"><img class="fp-compare__pouchEqImg" src="' + wetImg + '" alt="' + escapeHtml(wetName) + ' pouch"></div>';
            }
          html += '</div>';
        html += '</div>';
      
        // Weight graphic (only show when wet is heavier than Firepot)
        if (typeof extraWeightG !== 'undefined' && extraWeightG > 0) {
          html += '<div class="fp-compare__pouchEqMid">=</div>';
          html += '<div class="fp-compare__pouchEqCol fp-compare__pouchEqCol--weight">';
            html += '<div class="fp-compare__weightWrap">';
              html += '<img class="fp-compare__weightImg" src="https://cdn.shopify.com/s/files/1/1596/8375/files/weight.png?v=1769684854" alt="Weight">';
              html += '<div class="fp-compare__weightLabel"><span class="fp-compare__weightG">' + Math.round(extraWeightG) + 'g</span><span class="fp-compare__weightExtra">extra</span></div>';
            html += '</div>';
          html += '</div>';
        }
html += '</div>';
      return html;
    }

    // --- Summary lines (rules: only mention money if wet is more expensive)
    var summary1 = 'You would need <strong>' + fmt1(wetPouches) + '</strong> pouches of <strong>' + wetName + '</strong> to match the calories of a Firepot.';
    var summary2 = (extraCost > 0) ? ('That would cost you <strong>' + fmtPriceDelta(extraCost) + '</strong> more than a Firepot.') : '';
    var summary3 = 'That would weigh <strong>' + Math.round(Math.abs(extraWeightG)) + 'g</strong> ' + (extraWeightG >= 0 ? 'more' : 'less') + ' than a Firepot.';
    var summary4 = 'So taking <strong>' + wetName + '</strong> for a two‑night hike ' +
      (wkExtraCost > 0 ? ('takes <strong>' + fmtPriceDelta(wkExtraCost) + '</strong> from your wallet and ') : '') +
      'adds <strong>' + fmtKg(Math.abs(wkExtraWeightKg)) + '</strong> to your rucksack.';

    // --- Calculations (toggle)
    var fpTitle = (fp && fp.title) ? fp.title : 'Firepot meal';
    var wetTitle = (wet && (wet.product_name || wet.title)) ? normalizeCompetitorName((wet.product_name || wet.title)) : wetFull;
    var wetCostTotal = wetPouches * wetPrice;
    var wetWeightTotal = wetPouches * wetW;

    
        // FP COMPARE — CALC COPY SHORTENED + HIDE CHEAPER PRICE
    // FP COMPARE — REMOVED REDUNDANT calc2 PARAGRAPH
var calc1 = 'The Firepot pouch has ' + Math.round(fpKcal) + 'kcal compared to the ' + wetName + ' pouch which has ' + Math.round(wetKcal) + 'kcal. In order to get ' + Math.round(fpKcal) + 'kcal of the ' + wetName + ' meal you would therefore need to buy ' + fmt1(wetPouches) + ' pouches' + (extraCost > 0 ? ('. This would cost you £' + wetCostTotal.toFixed(2) + ' - £' + extraCost.toFixed(2) + ' more than a Firepot.') : '.') ;

    var calc3 = 'The Firepot weighs ' + Math.round(fpW) + 'g. The ' + wetName + ' weighs ' + Math.round(wetW) + 'g. ' + fmt1(wetPouches) + ' pouches of ' + wetName + ' would therefore weigh ' + Math.round(wetWeightTotal) + 'g - ' + Math.round(Math.abs(extraWeightG)) + 'g ' + (extraWeightG >= 0 ? 'more' : 'less') + ' than a Firepot.';

    var calc4 = 'A two day hike typically involves two main meals and two breakfasts. If you take ' + wetName + ' and each meal ' + (extraCost > 0 ? ('costs £' + extraCost.toFixed(2) + ' more and weighs ' + Math.round(Math.abs(extraWeightG)) + 'g ' + (extraWeightG >= 0 ? 'more' : 'less') + ' than a Firepot then you are spending an extra £' + (extraCost * 4).toFixed(2) + ' and carrying an extra ' + fmt1(Math.abs(extraWeightG) * 4 / 1000) + 'kg.') : ('weighs ' + Math.round(Math.abs(extraWeightG)) + 'g ' + (extraWeightG >= 0 ? 'more' : 'less') + ' than a Firepot then you are carrying an extra ' + fmt1(Math.abs(extraWeightG) * 4 / 1000) + 'kg.'));
    if(extraCost > 0){
      calc4 = 'A two day hike typically involves two main meals and two breakfasts. If you take ' + wetName + ' and each meal costs £' + extraCost.toFixed(2) + ' more and weighs ' + Math.round(Math.abs(extraWeightG)) + 'g more than a Firepot then you are spending an extra £' + (extraCost*4).toFixed(2) + ' and carrying an extra ' + ((Math.abs(extraWeightG)*4)/1000).toFixed(1) + 'kg.';
    } else {
      calc4 = 'A two day hike typically involves two main meals and two breakfasts. If you take ' + wetName + ' and each meal weighs ' + Math.round(Math.abs(extraWeightG)) + 'g more than a Firepot then you are carrying an extra ' + ((Math.abs(extraWeightG)*4)/1000).toFixed(1) + 'kg.';
    }


    var facts = '';
    facts += '<div class="fp-compare__factsBox" data-fp-facts-box>';
    facts += '<button type="button" class="fp-compare__calcBack" aria-label="Show summary" title="Show summary">×</button>';
    // MAIN (facts) view
    facts +=   '<div class="fp-compare__factsMain" data-fp-facts-main>';
    facts +=     '<div class="fp-compare__factsHeading">How do we compare?</div>';
    facts +=     buildPouchGraphic();
    facts +=     '<div class="fp-compare__wetSummary" data-fp-wet-summary>';
    facts +=       '<div class="fp-compare__wetLine fp-compare__wetLine--main">' + summary1 + '</div>';
    if (summary2) facts += '<div class="fp-compare__wetLine">' + summary2 + '</div>';
    facts +=       '<div class="fp-compare__wetLine">' + summary3 + '</div>';
    facts +=       '<div class="fp-compare__wetLine fp-compare__wetLine--twoNight">' + summary4 + '</div>';
    facts +=     '</div>';
    facts +=     '<div class="fp-compare__wetCalcs" data-fp-wet-calcs hidden>';
    facts +=       '<p>' + calc1 + '</p>';
    facts +=       '<p>' + calc3 + '</p>';
    facts +=       '<p>' + calc4 + '</p>';
    facts +=     '</div>';
    facts +=     '<div class="fp-compare__factsFooter"><button type="button" class="fp-compare__calcToggle" aria-expanded="false" data-fp-calc-label-open="Show summary" data-fp-calc-label-closed="See the calculations">See the calculations</button></div>';
    facts +=   '</div>';


    facts += '</div>';
    return facts;
  }



    async function render() {
      refreshDataCaches();

      // Keep visible mode and render mode locked together.
      // Prevents dropdown saying Wet meal equivalent while rendering the standard Firepot table.
      if (state.mode === 'wet' && state.view !== 'compare_wet') {
        state.view = 'compare_wet';
      }
      if (state.mode !== 'wet' && (!state.view || state.view === 'compare_wet')) {
        state.view = 'nutri_regular';
      }

      // Rebuild dropdown each render so disabled states stay accurate
      syncNoWetControlText();
      buildCombinedDropdown();
      if (root && root.classList) {
        root.classList.toggle('fp-compare--wet', state.view === 'compare_wet');
        root.classList.toggle('fp-compare--firepot', state.mode !== 'wet');
        root.classList.toggle('fp-compare--no-wet', !hasWetMatches);
      }

      state.showMobileFirepotPicker = false;
      state.mobileFirepotPickerIndex = null;
      state.mobileFirepotPickerHtml = '';

      var colHandles;
      if (state.view === 'compare_wet') {
        var wet = getWetMatches().slice(0, 2).map(function (m) {
          var id = String(m.id || m.comparison_id || '');
          return id ? ('comp:' + id) : '';
        }).filter(Boolean);
        colHandles = [currentHandle].concat(wet).slice(0, MAX_COLS_WET);
      
      } else {
        if (isProductCompareMobile()) {
          if (state.selected.length > 1) state.selected = state.selected.slice(0, 1);
          colHandles = [currentHandle].concat(state.selected).slice(0, 2);

          // Mobile Firepot mode uses the collection-style picker in the next column.
          if (colHandles.length < 2) {
            colHandles.push('');
            state.showMobileFirepotPicker = true;
            state.mobileFirepotPickerIndex = 1;
            state.mobileFirepotPickerHtml = buildMobileFirepotPickerHtml();
          }
        } else {
          colHandles = [currentHandle].concat(state.selected).slice(0, MAX_COLS_FIREPOT);
        }
      }

      // Column count:
      // - Wet compare = only FP + wet competitors (no empty placeholder columns)
      // - Firepot mobile = label + current product + picker/selected product
      // - Firepot desktop = pad to 6
      if (state.view === 'compare_wet') {
        // Wet compare: show only the columns we need (no phantom empty columns)
        // Always keep at least 2 columns (FP + 1 empty slot) so layout doesn't jump.
        while (colHandles.length < 2) colHandles.push('');
        CURRENT_MAX_COLS = Math.min(MAX_COLS_WET, colHandles.length);
      } else if (isProductCompareMobile()) {
        while (colHandles.length < 2) colHandles.push('');
        CURRENT_MAX_COLS = 2;
      } else {
        while (colHandles.length < MAX_COLS_FIREPOT) colHandles.push('');
        CURRENT_MAX_COLS = MAX_COLS_FIREPOT;
      }
var products = [];
      for (var i = 0; i < CURRENT_MAX_COLS; i++) {
        var h = colHandles[i];
        if (!h) { products.push(null); continue; }
        try {
          products.push(await getData(competitors, h));
        } catch (e) {
          log('data load failed', h, e);
          products.push({
            handle: h, title: h, url: '', img: '',
            tags: [], nutrition: {}, weights: {}, water: {},
            ingredients: '', allergens: ''
          });
        }
      }

      panel.classList.toggle('fp-compare--expanded', !!state.view);

      var out = '';
      if (!state.view) out = buildTableShell(state, products) + '</tbody></table>';
      else if (state.view === 'nutri_100g') out = renderNutrition(state, products, 'nutri_100g');
      else if (state.view === 'nutri_regular') out = renderNutrition(state, products, 'nutri_regular');
      else if (state.view === 'compare_wet') out = renderNutrition(state, products, 'nutri_regular');
      else if (state.view === 'nutri_xl') out = renderNutrition(state, products, 'nutri_xl');
      else if (state.view === 'water') out = renderWater(state, products);
      else if (state.view === 'ingredients') out = renderIngredients(state, products);
      else if (state.view === 'allergens') out = renderAllergens(state, products);
      else out = buildTableShell(state, products) + '</tbody></table>';
      if (state.view === 'compare_wet') {
        var facts = buildWetFactsHtml(products);
        out = '<div class="fp-compare__wetLayout">' +
              '<div class="fp-compare__wetTable">' + out + '</div>' +
              '<div class="fp-compare__wetFacts">' + facts + '</div>' +
              '</div>';
      }



      wrap.innerHTML = out;
      applyDebugKeylines(wrap);
      writeDebugMetrics(wrap);
    ensureWetFactsCalcToggle(wrap);


      // Offset the facts box so its top aligns with the first data row of the table
      // (i.e. below the product header THEAD), not the very top of the component.
      if (state.view === 'compare_wet') {
        requestAnimationFrame(function () {
          try {
            var thead = wrap.querySelector('.fp-compare__wetTable thead');
            var factsBox = wrap.querySelector('.fp-compare__wetFacts');
            if (thead && factsBox) {
              var h = Math.round(thead.getBoundingClientRect().height);
              factsBox.style.marginTop = (h + 24) + 'px';
            }
          } catch (e) {}
        });
      }
      bindTableButtons(wrap, removeAt);
    }

    // initial
    buildCombinedDropdown();
    render();
    ensureCurrentPriceGbp().then(function(){ render(); });

    // If this panel is inside a tab (often hidden on load), re-render once it becomes visible.
    // This fixes the case where competitor JSON is injected only when the tab is opened.
    (function ensureRenderWhenVisible(){
      var tries = 0;
      var maxTries = 80; // ~20s at 250ms
      var t = setInterval(function(){
        tries++;
        if (!document.body.contains(panel)) { clearInterval(t); return; }

        var rect = panel.getBoundingClientRect();
        var visible = rect.width > 10 && rect.height > 10;

        if (visible) {
          refreshDataCaches();
          // Wet mode should show immediately
          if (state.mode === 'wet') {
            state.view = 'compare_wet';
            panel.classList.add('fp-compare--expanded');
          }
          render();
          clearInterval(t);
          return;
        }

        if (tries >= maxTries) clearInterval(t);
      }, 250);
    })();
log('init done', { currentHandle: currentHandle });
  }

  function initAll() {
    qsa('[data-fp-product-compare-root]').forEach(initOne);
  }

  // Expose for debugging
  window.fpCompareInit = initAll;
  window.FP_COMPARE = window.FP_COMPARE || {};
  window.FP_COMPARE.version = 'v22-listref';
  window.FP_COMPARE.initAll = initAll;
  window.fpCompareRender = function(){ try { initAll(); } catch(e){} };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
})();

}
